import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const Counter = observer(class Counter extends React.Component {
  constructor() {
    super();
    this.countdown = this.countdown.bind(this);
    this.onExpire = this.onExpire.bind(this);
  }

  componentWillMount() {
    this.state = {
      counter: null,
      counterClass: ''
    }

    // Get current server time
    this.props.store.SessionStore.getCurrentTime(true);
  }

  componentDidMount() {
    const _this = this;
    const { SessionStore } = this.props.store;

    const timeDelay = setInterval(function(){
      if(!SessionStore.loading && SessionStore.currentTime) {
        clearInterval(timeDelay);

        _this.setState({
          currentTime: SessionStore.currentTime
        });

        _this.timer = setInterval(_this.countdown, 1000);
      }
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  countdown() {
    const now = this.state.currentTime;
    const expire = moment(this.props.endDate).subtract(5, 'seconds');
    const difference = new moment.duration(expire.diff(now));

    const newTime = moment(now).add(1, 'seconds');

    this.setState({
      currentTime: newTime
    });

    // console.log(`Now: ${now}`);
    // console.log(`Expire: ${expire}`);

    let countdown = {};

    countdown.days = difference.days();
    countdown.hours = difference.hours();
    countdown.minutes = difference.minutes();
    countdown.seconds = difference.seconds();

    // console.log(`Time Remaining: ${countdown.days}:${countdown.hours}:${countdown.minutes}:${countdown.seconds}`);

    if(countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0) {
      this.setState({
        counterClass: 'counter--ending'
      });
    } else {
      this.setState({
        counterClass: ''
      });
    }

    let counter = '';

    Object.keys(countdown).map(
      (key, i) => {
        if(countdown[key] < 0) {
          countdown[key] = 0;
        }

        if(
            (key === 'days' && countdown.days !== 0) ||
            (key === 'hours' && (countdown.days !== 0 || countdown.hours !== 0)) ||
            (key !== 'days' && key !== 'hours')
          ) {
          if(countdown[key] < 10) {
            countdown[key] = `0${countdown[key]}`
          }
          if(counter.length) {
            counter += `:${countdown[key]}`
          } else {
            counter += countdown[key]
          }
        }

        return true;
      }
    )

    this.setState({
      counter
    });

    // Expire
    if(countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0 && countdown.seconds <= 0) {
      this.onExpire();
    }
  }

  onExpire() {
    clearInterval(this.timer);

    if(this.props.callback) {
      this.props.callback();
    }
  }

  render() {
    const { translation } = this.props;

    return <span className="counter">{translation.time_remaining}: <strong className={`counter__time ${this.state.counterClass}`}>{this.state.counter}</strong></span>
  }
})

export default translate('Counter')(Counter);



// WEBPACK FOOTER //
// ./src/app/components/Counter/Counter.js